import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Row = ({ title, action, children, testid }) => {
  const scroller = useRef(null);

  const scroll = (dir) => {
    const el = scroller.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  return (
    <section className="group/row relative" data-testid={testid}>
      <div className="flex items-end justify-between mb-3 px-6 md:px-10">
        <h2 className="font-display text-xl md:text-2xl uppercase tracking-tight">{title}</h2>
        {action}
      </div>

      <div className="relative">
        <button
          onClick={() => scroll(-1)}
          aria-label="Scroll left"
          tabIndex={-1}
          className="hidden md:flex absolute left-0 top-0 bottom-2 z-20 w-14 items-center justify-center bg-gradient-to-r from-[#030305] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronLeft className="w-8 h-8 text-white" />
        </button>

        <div
          ref={scroller}
          className="flex gap-3 overflow-x-auto no-scrollbar px-6 md:px-10 py-3 -my-3 scroll-smooth"
        >
          {children}
        </div>

        <button
          onClick={() => scroll(1)}
          aria-label="Scroll right"
          tabIndex={-1}
          className="hidden md:flex absolute right-0 top-0 bottom-2 z-20 w-14 items-center justify-center bg-gradient-to-l from-[#030305] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity"
        >
          <ChevronRight className="w-8 h-8 text-white" />
        </button>
      </div>
    </section>
  );
};
